export default __webpack_public_path__ + "static/5e11d7578d30a82cb04e6067d6f6edba.png";